export const sliderItems = [
  {
    id: 1,
    img: 'https://images.unsplash.com/photo-1515446134809-993c501ca304?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
    title: 'THE WOODEN CIRCLE OF LIFE',
    desc: 'Best Craftsmanship , Highest Possible Standards, Only Selected Materials',
    bg: '#d2dae2',
    buttonTxt: 'WELCOME',
    url: '/welcome',
  },
  {
    id: 2,
    img: 'https://images.unsplash.com/photo-1617638924751-cc232f82ecf9?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
    title: '"EPOXY BULLET" ',
    desc: 'High quality , American Walnut Table- Order Now',
    bg: '#c8d6e5',
    buttonTxt: 'ORDER NOW',
    url: '/product/62b5a847d8601543983eb1e2',
  },
  {
    id: 3,
    img: 'https://images.unsplash.com/photo-1542360915390-e1a7b3ce8865?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1469&q=80',
    title: 'BIG SALE ON OFFICE FURNITURES',
    desc: 'Large selection on all office furnitures - now in low prices',
    bg: '#f1f2f6',
    buttonTxt: 'CHECK NOW',
    url: '/products/office',
  },
  {
    id: 4,
    img: 'https://images.unsplash.com/photo-1585128903994-9788298932a6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
    title: 'AFROMOSIA DINING TABLE',
    desc: 'Check our latest collection ',
    bg: '#dfe4ea',
    buttonTxt: 'CHECK NOW',
    url: '/products/latest',
  },
];

export const categories = [
  {
    id: 1,
    img: 'https://images.pexels.com/photos/8146218/pexels-photo-8146218.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: 'DINING TABLES',
    cat: 'table',
  },
  {
    id: 2,
    img: 'https://images.pexels.com/photos/6208155/pexels-photo-6208155.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: 'WOODEN ACCESSORIES',
    cat: 'kitchen',
  },
  {
    id: 3,
    img: 'https://images.unsplash.com/photo-1596639103739-91d96a629071?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2020&q=80',
    title: 'ART WORK',
    cat: 'art',
  },
];

export const cards = [
  {
    id: 1,
    img: 'https://cameroontimberexport.com/wp-content/uploads/2018/10/Rose-Wood-Logs.jpg',
    title: 'HIGH QUALITY MATERIALS',
    desc: 'For many years we have been building highest quality furnitures, wooden accessories any many other wood products. We know how important is the material that we using for production. We buying only selected kiln dried wood.',
    btnText: 'CHECK PRODUCTS',
    link: '/products/table',
  },
  {
    id: 2,
    img: 'https://i.ytimg.com/vi/uNJjzuAyJPQ/maxresdefault.jpg',
    title: 'BEST CRAFTSMANSHIP',
    desc: "To build the highest quality furnitures , we know that's not only materials but craftmanship is required. As a small family bussines, we carry from generation the secret technicks of wood crafting. So our customers are 100% satisfied.",
    btnText: 'REGISTER ACCOUNT',
    link: '/register',
  },
  {
    id: 3,
    img: 'https://cdn.windowsreport.com/wp-content/uploads/2020/04/furniture-design-software-1200x675.jpg',
    title: 'CUSTOM PROJECTS',
    desc: "First there is an idea, but everything starts on paper. Our designers making dreams of our client come true. Then the craftsman's are creating the highest quality products.",
    btnText: 'PROJECTS',
    link: '/product/62b5a3a7d8601543983eb1c8',
  },
];
